module.exports = __webpack_public_path__ + "img/office-desk-dark.270410ac.svg";